// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quantity-selector__item{display:flex;align-items:center;margin-bottom:var(--spacer-2)}.quantity-selector__item .btn{box-shadow:none;text-decoration:none}.quantity-selector__input{max-width:2.5rem;padding-left:var(--spacer-1);padding-right:var(--spacer-1);text-align:center}.quantity-selector__label{font-size:var(--font-size-sm);line-height:var(--line-height-sm);margin-left:var(--spacer-1)}.quantity-selector .alert{max-width:300px;margin-bottom:0;margin-top:var(--spacer-3)}", ""]);
// Exports
module.exports = exports;
